export const teams = [
  {
    id: 1,
    name: "Schwehr / Bunn",
    players: ["Matt Schwehr", "Connor Bunn"],
    images: ["schwehr.jpeg", "connor_bunn.jpeg"],
    rankings: [1, 22],
    odds: "+250",
    handicap: -6,
  },
  {
    id: 2,
    name: "Cancilla / Campbell",
    players: ["Nick Cancilla", "Aron Campbell"],
    images: ["cancilla.jpeg", "campbell.jpeg"],
    rankings: [2, 21],
    odds: "+300",
    handicap: -6,
  },
  {
    id: 3,
    name: "Worlidge / Odame",
    players: ["Matt Worlidge", "John Odame"],
    images: ["worlidge.jpeg", "john_odame.jpeg"],
    rankings: [3, 20],
    odds: "+350",
    handicap: -6,
  },
  {
    id: 4,
    name: "E. Opie / Hawke",
    players: ["Ellis Opie", "Austin Hawke"],
    images: ["ellis.jpeg", "hawke.jpeg"],
    rankings: [4, 19],
    odds: "+400",
    handicap: -6,
  },
  {
    id: 5,
    name: "Bajzik / B. Opie",
    players: ["Trevor Bajzik", "Brett Opie"],
    images: ["bajzik.jpeg", "opie.jpeg"],
    rankings: [5, 18],
    odds: "+450",
    handicap: -6,
  },
  {
    id: 6,
    name: "Fobert / Flanagan",
    players: ["John Fobert", "Ryan Flanagan"],
    images: ["fobert.jpeg", "flanagan.jpeg"],
    rankings: [6, 17],
    odds: "+500",
    handicap: -6,
  },
  {
    id: 7,
    name: "Myers / Cochrane",
    players: ["Mac Myers", "Tyler Cochrane"],
    images: ["myers.jpeg", "cochrane.jpeg"],
    rankings: [7, 16],
    odds: "+550",
    handicap: -6,
  },
  {
    id: 8,
    name: "Petrie / Mason",
    players: ["Brandon Petrie", "Brandon Mason"],
    images: ["petrie.jpeg", "mason.jpeg"],
    rankings: [8, 15],
    odds: "+600",
    handicap: -6,
  },
  {
    id: 9,
    name: "Johnston / Heine",
    players: ["Connor Johnston", "Ryan Heine"],
    images: ["johnson.jpeg", "ryan_heine.jpg"],
    rankings: [9, 14],
    odds: "+650",
    handicap: -6,
  },
  {
    id: 10,
    name: "R. Opie / O'Brien",
    players: ["Ryan Opie", "Dylan O'Brien"],
    images: ["r opie.jpeg", "o'brien.jpeg"],
    rankings: [10, 13],
    odds: "+700",
    handicap: -6,
  },
  {
    id: 11,
    name: "Atkinson / Cornford",
    players: ["Trevor Atkinson", "Graham Cornford"],
    images: ["atkinson.jpeg", "cornford.jpeg"],
    rankings: [11, 12],
    odds: "+750",
    handicap: -6,
  },
  {
    id: 12,
    name: "Aaron Campbell / Stanisz",
    players: ["Aaron Campbell", "Rob Stanisz"],
    images: ["aaron_campbell.jpeg", "stanisz.jpeg"],
    rankings: [0, 0],
    odds: "+800",
    handicap: -6,
  },
];
